import ReactDOM from 'react-dom/client';
import App from './App'
import './index.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle'
import 'react-toastify/dist/ReactToastify.css';
import 'aos/dist/aos.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
